import { useEffect } from 'react';
import { SystemBars, SystemBarsStyle } from '@capacitor/core';
import { isNativePlatform } from '@/utils/capacitor';

/**
 * Capacitor 8 SystemBarsStyle:
 * - LIGHT → ikon gelap (jam/baterai hitam) untuk latar putih/abu
 * - DARK → ikon terang (jam/baterai putih) untuk latar oranye/gelap
 */
export type NativeSystemBarsStyle = 'DARK' | 'LIGHT';

export function systemBarsIconsForBackground(
  background: 'light' | 'dark'
): NativeSystemBarsStyle {
  return background === 'light' ? 'LIGHT' : 'DARK';
}

export function useSystemBarsStyle(style: NativeSystemBarsStyle): void {
  useEffect(() => {
    if (!isNativePlatform()) {
      return;
    }

    const mapped = style === 'DARK' ? SystemBarsStyle.Dark : SystemBarsStyle.Light;
    try {
      void SystemBars.setStyle({ style: mapped }).catch(() => undefined);
    } catch {
      // SystemBars may be unavailable outside a native WebView
    }
  }, [style]);
}
